export * from "-!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./Boekingen.vue?vue&type=template&id=1d54fe34&scoped=true&"


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/Boekingen.vue?vue&type=template&id=1d54fe34&scoped=true&
// module id = 437
// module chunks = 0